module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.bff900f.woff";